var r=function(r){return!Array.isArray(r)};export{r as isHtmlStringInstruction};
